import React, { useEffect, useState } from 'react';
import { whatsappAPI } from './whatsappAPI';
import { toast } from 'sonner';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Trash2, Plus } from 'lucide-react';

export default function TemplatesWA() {
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ titulo:'', conteudo:'', categoria:'geral' });
  const load = async () => { try{const r=await whatsappAPI.templatesList();setItems(r.data||[]);}catch(e){} };
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!f.titulo || !f.conteudo) return toast.error('Preencha título e conteúdo');
    try{ await whatsappAPI.templateCreate(f); setF({titulo:'',conteudo:'',categoria:'geral'}); load(); toast.success('Template criado'); }catch(e){toast.error('Falha');}
  };
  const del = async (id) => { if(!window.confirm('Excluir?'))return; await whatsappAPI.templateDelete(id); load(); };

  return (
    <div className="space-y-4" data-testid="wa-templates-page">
      <Card className="p-4">
        <h3 className="font-semibold mb-3">Novo Template</h3>
        <p className="text-xs text-muted-foreground mb-2">Variáveis suportadas: <code>{'{{nome_cliente}}'}</code>, <code>{'{{numero_projeto}}'}</code>, <code>{'{{etapa_atual}}'}</code></p>
        <div className="grid gap-2">
          <Input placeholder="Título" value={f.titulo} onChange={e=>setF({...f,titulo:e.target.value})} data-testid="wa-tpl-titulo" />
          <textarea rows={3} className="w-full border rounded p-2 text-sm bg-background" placeholder="Conteúdo da mensagem..." value={f.conteudo} onChange={e=>setF({...f,conteudo:e.target.value})} data-testid="wa-tpl-conteudo" />
          <div className="flex gap-2">
            <Input placeholder="Categoria" value={f.categoria} onChange={e=>setF({...f,categoria:e.target.value})} className="flex-1" />
            <Button onClick={save} data-testid="wa-tpl-save"><Plus className="w-4 h-4 mr-1"/>Adicionar</Button>
          </div>
        </div>
      </Card>
      <div className="grid gap-3">
        {items.map(t => (
          <Card key={t.id} className="p-3 flex justify-between items-start">
            <div className="flex-1"><p className="font-semibold">{t.titulo}</p><p className="text-sm text-muted-foreground whitespace-pre-wrap">{t.conteudo}</p><span className="text-[10px] bg-slate-100 dark:bg-slate-800 px-2 py-0.5 rounded">{t.categoria}</span></div>
            <Button size="sm" variant="ghost" onClick={()=>del(t.id)}><Trash2 className="w-4 h-4 text-red-600" /></Button>
          </Card>
        ))}
        {items.length===0 && <p className="text-center text-muted-foreground p-4">Nenhum template</p>}
      </div>
    </div>
  );
}
